import { createActionTypes } from '../../state/actions'

export const GET_SITE_AUDIT_DATA = createActionTypes('GET_SITE_AUDIT_DATA')
export const getSiteAuditDataAction = (
  siteAuditDomainType,
  domain,
  mode,
  useCache,
  locId,
  lang,
) => ({
  type: GET_SITE_AUDIT_DATA.action,
  siteAuditDomainType,
  domain,
  mode,
  useCache,
  locId,
  lang,
})

export const GET_PROJECT_SITE_AUDIT_DATA = createActionTypes(
  'GET_PROJECT_SITE_AUDIT_DATA',
)

export const getProjectSiteAuditDataAction = (payload) => ({
  type: GET_PROJECT_SITE_AUDIT_DATA.action,
  payload,
})

export const CRAWL_SITE_AUDIT = createActionTypes('CRAWL_SITE_AUDIT')
export const crawlSiteAuditAction = (payload) => ({
  type: CRAWL_SITE_AUDIT.action,
  payload,
})
export const crawlSiteAuditDataActionPolling = (payload) => ({
  type: CRAWL_SITE_AUDIT.polling,
  payload,
})
export const crawlSiteAuditActionFailed = (payload) => ({
  type: CRAWL_SITE_AUDIT.failed,
  payload,
})
export const crawlSiteAuditActionSuccess = (payload) => ({
  type: CRAWL_SITE_AUDIT.success,
  payload,
})

export const CRAWL_PROJECT_SITE_AUDIT = createActionTypes(
  'CRAWL_PROJECT_SITE_AUDIT',
)
export const crawlProjectSiteAuditDataActionPolling = (payload) => ({
  type: CRAWL_PROJECT_SITE_AUDIT.polling,
  payload,
})
export const crawlProjectSiteAuditActionFailed = (payload) => ({
  type: CRAWL_PROJECT_SITE_AUDIT.failed,
  payload,
})
export const crawlProjectSiteAuditActionSuccess = (payload) => ({
  type: CRAWL_PROJECT_SITE_AUDIT.success,
  payload,
})

export const CRAWL_PARTIAL_SITE_AUDIT = createActionTypes(
  'CRAWL_PARTIAL_SITE_AUDIT',
)
export const crawlPartialSiteAuditAction = (payload, onComplete) => ({
  type: CRAWL_PARTIAL_SITE_AUDIT.action,
  payload,
  onComplete,
})
export const crawlPartialSiteAuditActionPolling = (payload, onComplete) => ({
  type: CRAWL_PARTIAL_SITE_AUDIT.polling,
  payload,
  onComplete,
})
export const crawlPartialSiteAuditActionFailed = (payload) => ({
  type: CRAWL_PARTIAL_SITE_AUDIT.failed,
  payload,
})
export const crawlPartialSiteAuditActionSuccess = (payload) => ({
  type: CRAWL_PARTIAL_SITE_AUDIT.success,
  payload,
})

export const STOP_SITE_AUDIT = createActionTypes('STOP_SITE_AUDIT')
export const stopSiteAuditAction = (payload, onComplete) => ({
  type: STOP_SITE_AUDIT.action,
  payload,
  onComplete,
})
export const stopSiteAuditActionSuccess = (payload) => ({
  type: STOP_SITE_AUDIT.success,
  payload,
})

export const GET_LIGHTHOUSE_BENCHMARK = createActionTypes(
  'GET_LIGHTHOUSE_BENCHMARK',
)
export const getLighthouseBenchMarkAction = (payload) => ({
  type: GET_LIGHTHOUSE_BENCHMARK.action,
  payload,
})
export const getLighthouseBenchMarkActionSuccess = (payload) => ({
  type: GET_LIGHTHOUSE_BENCHMARK.success,
  payload,
})
export const getLighthouseBenchMarkActionFailed = (error) => ({
  type: GET_LIGHTHOUSE_BENCHMARK.failed,
  error,
})

export const GET_PROJECT_LIGHTHOUSE_BENCHMARK = createActionTypes(
  'GET_PROJECT_LIGHTHOUSE_BENCHMARK',
)

export const getProjectLighthouseBenchMarkActionSuccess = (payload) => ({
  type: GET_PROJECT_LIGHTHOUSE_BENCHMARK.success,
  payload,
})
export const getProjectLighthouseBenchMarkActionFailed = (error) => ({
  type: GET_PROJECT_LIGHTHOUSE_BENCHMARK.failed,
  error,
})

export const GET_PAGES_DISCOVERED = createActionTypes('GET_PAGES_DISCOVERED')
export const getPagesDiscoveredAction = (payload) => ({
  type: GET_PAGES_DISCOVERED.action,
  payload,
})
export const getPagesDiscoveredActionSuccess = (payload) => ({
  type: GET_PAGES_DISCOVERED.success,
  payload,
})
export const getPagesDiscoveredActionFailed = (error) => ({
  type: GET_PAGES_DISCOVERED.failed,
  error,
})

export const GET_ISSUE_BREAKDOWN = createActionTypes('GET_ISSUE_BREAKDOWN')
export const getIssueBreakdownAction = (payload) => ({
  type: GET_ISSUE_BREAKDOWN.action,
  payload,
})
export const getIssueBreakdownActionSuccess = (payload) => ({
  type: GET_ISSUE_BREAKDOWN.success,
  payload,
})
export const getIssueBreakdownActionFailed = (payload) => ({
  type: GET_ISSUE_BREAKDOWN.failed,
  payload,
})

export const GET_OVERVIEW = createActionTypes('GET_OVERVIEW')
export const getOverviewAction = (payload) => ({
  type: GET_OVERVIEW.action,
  payload,
})
export const getOverviewActionSuccess = (payload) => ({
  type: GET_OVERVIEW.success,
  payload,
})
export const getOverviewActionFailed = (payload) => ({
  type: GET_OVERVIEW.failed,
  payload,
})

export const GET_PROJECT_OVERVIEW = createActionTypes('GET_PROJECT_OVERVIEW')
export const getProjectOverviewAction = (payload) => ({
  type: GET_PROJECT_OVERVIEW.action,
  payload,
})
export const getProjectOverviewActionSuccess = (payload) => ({
  type: GET_PROJECT_OVERVIEW.success,
  payload,
})
export const getProjectOverviewActionFailed = (payload) => ({
  type: GET_PROJECT_OVERVIEW.failed,
  payload,
})

export const ADD_NOTIFICATION = createActionTypes('ADD_NOTIFICATION')
export const addNotificationAction = (payload) => ({
  type: ADD_NOTIFICATION.action,
  payload,
})

export const REMOVE_NOTIFICATION = createActionTypes('REMOVE_NOTIFICATION')
export const removeNotificationAction = (payload) => ({
  type: REMOVE_NOTIFICATION.action,
  payload,
})

export const UPDATE_ISSUES = createActionTypes('UPDATE_ISSUES')
export const updateIssues = (payload, onComplete) => ({
  type: UPDATE_ISSUES.action,
  payload,
  onComplete,
})

export const DISPLAY_UPGRADE_MODAL = createActionTypes('DISPLAY_UPGRADE_MODAL')
export const displayUpgradeModalAction = () => ({
  type: DISPLAY_UPGRADE_MODAL.action,
})
export const displayUpgradeModalActionSuccess = () => ({
  type: DISPLAY_UPGRADE_MODAL.success,
})

export const CANCEL_SITE_AUDIT = createActionTypes('CANCEL_SITE_AUDIT')

export const cancelSiteAuditAction = () => ({
  type: CANCEL_SITE_AUDIT.action,
})

export const CHANGE_SITE_AUDIT_DOMAIN_TYPE = createActionTypes(
  'CHANGE_SITE_AUDIT_DOMAIN_TYPE',
)

export const changeSiteAuditDomainTypeAction = (siteAuditDomainType) => ({
  type: CHANGE_SITE_AUDIT_DOMAIN_TYPE.action,
  siteAuditDomainType,
})
